// ** Auth Endpoints
export default {
  loginEndpoint: "/api/auth/user/login",
  adminLogin: "/api/auth/login",
  registerEndpoint: "/api/auth/signup",
  refreshEndpoint: "/api/auth/refresh-token",
  logoutEndpoint: "/jwt/logout",
  reCaptchaEndpoint: "/api/google/recaptcha/v3",
  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: "Bearer",

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: "accessToken",
  storageRefreshTokenKeyName: "refreshToken",
};
